//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    typeMaterial: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    stoneTypes: {
      type: Array,
      default() {
        return []
      }
    },
    symbols: {
      type: Array,
      default() {
        return []
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    },
    total: {
      type: String,
      default() {
        return '0'
      }
    },
  },
  inject: ['productAnimate'],
  data() {
    return {
      characterLimit: 5,
      text: '',
    }
  },
  methods: {
    selectedProduct(el) {
      let arr = el.configuration_id.split('-');

      const stones = [];

      const attr = []

      for (const key in this.bootstrap.data.attributes) {
        attr.push(this.bootstrap.data.attributes[key])
      }

      const stoneTypes = [attr.filter(item => item.group_id === 3).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 9).map(item => {
        return {...item, title: item.name}
      })];
      const stoneShapes = [attr.filter(item => item.group_id === 4 || item.group_id === 11).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 5).map(item => {
        return {...item, title: item.name}
      })];

      const symbols = attr.filter(item => item.group_id === 11).map(item => {
        return {...item, title: item.name}
      });
      arr.forEach((item, i) => {
        if (i && i < (arr.length - 1)) {
          const a = {};
          if (stoneShapes[0]
            && stoneShapes[0].some(item => item.sku_part === arr[i].substr(0, 2))) {
            a.ss = stoneShapes.find(item => item.sku_part === arr[i].substr(0, 2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.ss = symbols.find(item => item.sku_part === arr[i])
          }
          if (stoneTypes[0]
            && stoneTypes[0].some(item => item.sku_part === arr[i].substr(2))) {
            a.st = stoneTypes[0].find(item => item.sku_part === arr[i].substr(2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.st = symbols.find(item => item.sku_part === arr[i])
          }
          stones.push(a)
        }
      })
      return {
        stones,
        m: this.typeMaterial.find(item => item.value === arr[arr.length - 1])
      }
    },
    changeBail(item) {
      if(!item) {
        this.productAnimate.forcedShow = true;
      }
      let temp = this.$route.query.configId.split(',');
      temp[1] = item ? item.configuration_id : '';
      temp = temp.join(',');
      const query = {...this.$route.query, configId: temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
    },
    async back() {
      this.$parent.$emit('changeStage', 'configurator')
    },
    async close() {
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
  computed: {
    bootstrap() {
      return this.$store.getters.getBootstrap;
    },
  },
  mounted() {
  }
}
